module.exports = __webpack_public_path__ + "img/banner-event.61961897.svg";